import { render, staticRenderFns } from "./StartupModificationForm.vue?vue&type=template&id=63011fe8"
import script from "./StartupModificationForm.vue?vue&type=script&lang=js"
export * from "./StartupModificationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports